import React from 'react';
import { Donut } from 'd3plus-react';
import PropTypes from 'prop-types';
import ListSelectCoursesDashboard from './ListSelectCoursesDashboard';
import StatusCard from './StatusCard';


class DashboardCourses extends React.Component {
  state = {
    selected: null,
  };

  render() {
    const { courses } = this.props;
    const { selected } = this.state;

    const totalStudents = selected ? selected.totals.reduce((acc, item) => acc + item.value, 0) : 0;
    const config = {
      groupBy: 'id',
      data: selected ? selected.totals.map(total => ({ id: total.name, value: total.value, color: total.color })) : [],
      loadingHTML: 'Carregando..',
      color: d => d.color,
      duration: 0,
      legend: false,
      tooltipConfig: {
        body: d => (d.value / totalStudents).toLocaleString(undefined, { style: 'percent', minimumFractionDigits: 2 }),
      },
    };

    return (
      <div className="bg-silver--lighter mt-4 p-4">
        <div className="row">
          <div className="col-lg-3 col-md-3 col-xs-12 col-sm-12">
            <ListSelectCoursesDashboard courses={courses} value={selected} onClick={e => this.setState({ selected: e })} />
          </div>
          <div className="col-lg-9 col-md-9 col-xs-12 col-sm-12">
            {selected ? (
              <div className="row">
                <div className="col-lg-6 col-md-6 col-xs-6 col-sm-12">
                  <div className="height-300 mt-3">
                    <Donut config={config} />
                  </div>
                </div>
                <div className="col-lg-6 col-md-6 col-xs-6 col-sm-12">
                  {selected.totals.map(total => (
                    <StatusCard key={total.name} status={total} />
                  ))}
                </div>
              </div>
            ) : <p className="text-center mb-0 mt-4">Selecione uma disciplina para ver as informações</p>}
          </div>
        </div>
      </div>
    );
  }
}

DashboardCourses.propTypes = {
  courses: PropTypes.arrayOf(PropTypes.object),
};

DashboardCourses.defaultProps = {
  courses: [],
};

export default DashboardCourses;
